import * as React from 'react'
import * as _ from 'lodash'
import './TopMenu.css'

import { NetworkUser } from 'golgi'
import { standardSCU } from '../util'
import StepProps from './StepProps'
import * as Model from '../types/document'
import { Cursor, CursorV } from 'src/lib/Cursor';
import DragNew from 'src/view/DragNew';
import { documentC } from 'src/globals';
import DefinitionCard from 'src/view/DefinitionCard';

class TopMenu extends React.Component<{
  documentC: Cursor<Model.Document>
}> {

  state = { definitionsExpanded: true }

  render() {
    const { definitionsExpanded } = this.state

    return <NetworkUser debugName="NetworkUser" props={this.props} state={this.state} render={() => {
      return <div className="TopMenu">
        <div className="TopMenu-draggables">
          <span className="TopMenu-draggables-heading">Drag new</span>
          <DragNew drag={{type: 'node'}}>
            <span className="TopMenu-draggable">
              <span className="TopMenu-draggable-label">
                node
              </span>
            </span>
          </DragNew>
          {" "}
          <DragNew drag={{type: 'text'}}>
            <span className="TopMenu-draggable">
              <span className="TopMenu-draggable-label">
                text
              </span>
            </span>
          </DragNew>
          {" "}
          <DragNew drag={{type: 'switch'}}>
            <span className="TopMenu-draggable">
              <span className="TopMenu-draggable-label">
                switch
              </span>
            </span>
          </DragNew>
        </div>
        { definitionsExpanded &&
          <div className="TopMenu-definitions">
            {documentC._('definitions').fetch().call(CursorV.elems).map((definitionC, i) =>
              <DefinitionCard
                key={definitionC.value().id}
                definitionId={definitionC.value().id}
                index={i} />
            )}
          </div>
        }
        <div className="TopMenu-definitions-expander"
             onClick={() => this.setState({definitionsExpanded: !definitionsExpanded})}>
          { definitionsExpanded ? "▴" : "▾"}
        </div>
      </div>
    }} />
  }
}

export default TopMenu;



// WEBPACK FOOTER //
// ./src/view/TopMenu.tsx